export default {
    'games.codelish.com': {
        type: 'users',
        name: 'codelish'
    },
    'games.sonic.family': {
        type: 'users',
        name: 'sergej'
    }
}